import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchComplianceStatus, fetchPendingActions, fetchRecentActivity, } from "../../../service/api";


export const getRecentActivitiee = createAsyncThunk(
    "recent/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRecentActivity(params)
            console.log("recent activity", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getComplianceStatus = createAsyncThunk(
    "compliance/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchComplianceStatus(params)
            console.log("compliance status", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getPendingActions = createAsyncThunk(
    "actons/getAction",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPendingActions(params)
            console.log("pending action ", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

const recentActivitySlice = createSlice({
    name: "recents",
    initialState: {
        recentActivity: [],
        complianceStatus: [],
        pendingActions: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        roomId: "",
        dates: "",
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            //RECENT GET
            .addCase(getRecentActivitiee.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getRecentActivitiee.fulfilled, (state, action) => {
                state.isLoading = false;
                state.recentActivity = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getRecentActivitiee.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //COMPLIANCE GET
            .addCase(getComplianceStatus.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getComplianceStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.complianceStatus = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getComplianceStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })
            // ACTIONS
            .addCase(getPendingActions.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getPendingActions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.pendingActions = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getPendingActions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

    }
})

// export const { setDateFilters, setRoomFilters, setSearchParams, setPagination } = activitySlice.actions;

export default recentActivitySlice.reducer;
